import Dictionary from '../interfaces/Dictionary';
import Labels from '../enums/Labels';

const dictionary: Dictionary = {
  [Labels.SELECTED_DATE]: 'Selected date',
  [Labels.SELECT_DATE]: 'Select date',
  [Labels.LISTEN]: 'Listen',
  [Labels.CURRENTLY_AT]: 'You are currently at',
  [Labels.ATTENTION_REQUIRED_AT]: 'Your attention is required at',
  [Labels.LOG_OUT]: 'Log out',
  [Labels.NEXT_STEP]: 'Next',
  [Labels.PROCEED_TO_SIGNING]: 'Proceed to signing',
  [Labels.PROCEED_TO_SIGNING_WEFOX]: 'Proceed to the signature',
  [Labels.EDIT_HEALTH_DECLARATION]: 'Edit health declaration',
  [Labels.VIEW_HEALTH_DECLARATION]: 'View health declaration',
  [Labels.VIEW_MEDICAL_REASON]: 'View explanation assessment advice',
  [Labels.PLEASE_WAIT]: 'Please wait..',
  [Labels.MR]: 'Mr.',
  [Labels.MS]: 'Ms.',
  [Labels.INSTRUCTIONS_WELCOME_HEADER]:
    'Welcome to the TAF health declaration.',
  [Labels.INSTRUCTIONS_WELCOME_TEXT]:
    'A TAF {0} has been requested with you as the insured party. Therefore we ask you to fill in a digital health declaration.',
  [Labels.INSTRUCTIONS_SIGN_ONLINE_HEADER]: 'Sign online',
  [Labels.INSTRUCTIONS_SIGN_ONLINE_TEXT]:
    "Once you have filled in your health declaration, you will receive a verification code via text message on the mobile number you have provided. You can digitally sign your declaration with this code. The health declaration will then be sent to us automatically. If you'd like more information about completing your health declaration, take a look at the video below.",
  [Labels.INSTRUCTIONS_AFTER_SIGNING_HEADER]: 'What happens after signing?',
  [Labels.INSTRUCTIONS_AFTER_SIGNING_TEXT]:
    'After we have received the completed health declaration, the assessment begins. There are two outcomes:',
  [Labels.INSTRUCTIONS_AFTER_SIGNING_SUPPLEMENTAL]:
    'Sedgwick may request additional medical information and/or you may need to be examined by an approval authority. In the \'Medical assessment upon acceptance\' at <a href="http://www.taf.nl/" target="_blank" rel="noopener noreferrer">www.taf.nl</a> you can read exactly how the medical assessment works.',
  [Labels.INSTRUCTIONS_AFTER_SIGNING_LIST_ITEM_1]:
    'Your application will be accepted immediately.',
  [Labels.INSTRUCTIONS_AFTER_SIGNING_LIST_ITEM_1_EXPLANATION]:
    'If there are no medical specifics, you will receive the policy by e-mail within 24 hours on working days.',
  [Labels.INSTRUCTIONS_AFTER_SIGNING_LIST_ITEM_2]:
    'Your application will be assessed by a Sedgwick medical advisor.',
  [Labels.INSTRUCTIONS_AFTER_SIGNING_LIST_ITEM_2_EXPLANATION]:
    'If there are any medical specifics, your application will be assessed by independent medical consulting company Sedgwick. The medical advisor will advise the insurer whether or not he can accept your application, and if so, under what conditions.',
  [Labels.INSTRUCTIONS_IMPORTANT_REMARKS_HEADER]: 'Important points',
  [Labels.INSTRUCTIONS_IMPORTANT_REMARKS_TEXT]:
    'You will find a detailed explanation of this health declaration on <a href="https://www.taf.nl/algemeen/toelichting-gezondheidsverklaring" target="_blank" rel="noopener noreferrer">our website</a>. This explanation is an integral part of this form, so please read it carefully.',
  [Labels.INSTRUCTIONS_IMPORTANT_REMARKS_LIST_ITEM_1]:
    'Answer the questions correctly and completely.',
  [Labels.INSTRUCTIONS_IMPORTANT_REMARKS_LIST_ITEM_1_EXPLANATION]:
    'This is called your duty of disclosure. It prevents that, for example:',
  [Labels.INSTRUCTIONS_IMPORTANT_REMARKS_LIST_ITEM_2]:
    'Make a mention of all your complaints',
  [Labels.INSTRUCTIONS_IMPORTANT_REMARKS_LIST_ITEM_2_EXPLANATION]:
    'Even if you think they are not important or if you have not (yet) seen a doctor.',
  [Labels.INSTRUCTIONS_IMPORTANT_REMARKS_LIST_ITEM_3]:
    'An illness, disorder or complaint (now or in the past) does not immediately lead to a higher premium or a rejection of your application.',
  [Labels.INSTRUCTIONS_IMPORTANT_REMARKS_LIST_ITEM_3_EXPLANATION]:
    'The goal is to properly assess your medical health, so that you are ultimately well insured.',
  [Labels.INSTRUCTIONS_IMPORTANT_REMARKS_SUB_LIST_ITEM_1]:
    'Your insurance stops in the future.',
  [Labels.INSTRUCTIONS_IMPORTANT_REMARKS_SUB_LIST_ITEM_2]:
    'You are not entitled to any benefits.',
  [Labels.INSTRUCTIONS_DISCLAIMER_HEADER]: 'Disclaimer',
  [Labels.INSTRUCTIONS_DISCLAIMER_TEXT]:
    'Based on the submitted information, an automated decision will be made on your contract, including any potential exclusions and the premium amount. By clicking on "Next", you give us your consent to make the automated decision.',
  [Labels.INSTRUCTIONS_CHECKBOX_TITLE]:
    'I have read and understand this information and certify that I will answer the questions in the health declaration truthfully.',
  [Labels.INSTRUCTIONS_CHECKBOX_TITLE_MAGNUM]:
    'By checking this box, I declare that I will answer the questions in this health statement truthfully.',
  [Labels.INSTRUCTIONS_CHECKBOX_TITLE_WEFOX]:
    'By ticking this box, I declare that I have answered the questions in this I will answer the health declaration truthfully. If I have any doubts whether If something needs to be stated, I will provide the facts known to me in the statement final statement.',
  [Labels.INSTRUCTIONS_CHECKBOX_TITLE_DHMR]:
    'By checking this box, I declare that I will answer and provide the requested information completely and truthfully. If I am in doubt as to whether something should be stated, I will state the facts known to me in the explanation above the final statement.',
  [Labels.COMPLETE_HEADER]: 'Completing your TAF Online Health Declaration',
  [Labels.COMPLETE_WEFOX_HEADER]: 'Completing your health questions',
  [Labels.COMPLETE_DHMR_HEADER]: 'Wrapping up',
  [Labels.COMPLETE_CHECKBOX_TITLE1]:
    'I agree that {0} can process my personal information for the assessment of the application and to act upon the insurance agreement.',
  [Labels.COMPLETE_CHECKBOX_TITLE2]:
    'I agree that the conclusion of the medical assessment (rejection, exclusion clauses, extra premium, etc.), will be communicated to the insurer.',
  [Labels.COMPLETE_CHECKBOX_TITLE3]: 'My mobile phone number is',
  [Labels.COMPLETE_WEFOX_CHECKBOX_TITLE1]:
    'My information in this health declaration is complete and correct',
  [Labels.COMPLETE_WEFOX_CHECKBOX_TITLE2]:
    'I have taken note of the notification pursuant to Section 19 Paragraph 5 VVG regarding the consequences of a <a href="http://wefox.com/risikolebensversicherung/anzeigepflicht">violation of the pre-contractual notification obligation</a>',
  [Labels.COMPLETE_WEFOX_CHECKBOX_TITLE3]:
    'With my signature I give my consent to <a href="http://wefox.com/risikolebensversicherung/einwilligung">data processing and a declaration of release from confidentiality</a>',
  [Labels.COMPLETE_WEFOX_CHECKBOX_TITLE4]:
    'I have read the <a href="http://wefox.com/risikolebensversicherung/datenschutz">data protection information</a>',
  [Labels.COMPLETE_WEFOX_CHECKBOX_TITLE5]:
    'I am aware of the provisions of this health declaration and accept them as part of the insurance application',
  [Labels.COMPLETE_WEFOX_CHECKBOX_TITLE6]:
    'I am aware that I must inform wefox immediately if my health status changes after I have completed the health declaration but before wefox has definitely admitted me.',
  [Labels.COMPLETE_P1]:
    'Are you sure you have completed all the questions completely?  This means that you have listed all complaints, diseases or conditions.  Even if you think they are not important or if you have not (yet) seen a doctor, had treatment or taken medication. This will prevent you from possibly not being entitled to benefits. Then you can sign and send your health statement now.',
  [Labels.COMPLETE_WEFOX_P1]:
    'Have you answered all the questions and is your cell phone number correct? Confirm this here and you can proceed to sign the health declaration.',
  [Labels.COMPLETE_DHMR_P1]:
    'Have you answered the questions, attached your medical file and your previous health certificate? And is your telephone number correct? Please confirm this here and you can proceed to signing this statement.',
  [Labels.COMPLETE_WEFOX_P2]: 'I',
  [Labels.COMPLETE_P3]: 'I',
  [Labels.COMPLETE_P3_TAF]: 'Your mobile number is: ',
  [Labels.COMPLETE_P4_1_TAF]:
    'The verification code that you need to digitally sign the health statement will be sent to this number. Is this number incorrect? Then click on “Your data” at the top of the page. There you can change your number',
  [Labels.COMPLETE_WEFOX_P3]: 'hereby declare that:',
  [Labels.COMPLETE_P4]: 'hereby declare that:',
  [Labels.COMPLETE_WEFOX_P4]:
    'A verification code will be sent to the phone number above which you can use to sign the health declaration. If this number is incorrect, please change it in the {0} tab.',
  [Labels.COMPLETE_WEFOX_P5]:
    'Important: It is important that you always let us know if your medical situation changes after you have completed the health declaration but before the insurance is accepted.',
  [Labels.COMPLETE_DHMR_P5]:
    'Naar het bovenstaande telefoonnummer zal een verificatiecode worden gestuurd waarmee u deze verklaring met uw medisch dossier kunt ondertekenen.',
  [Labels.COMPLETE_WEFOX_P6]:
    "If you click on 'Continue to Sign' below, your health declaration will be presented for digital signature.",
  [Labels.COMPLETE_P7]:
    "If you click 'proceed to signing' below, your health declaration will be submitted for digital signing.",
  [Labels.COMPLETE_DHMR_LI1]:
    'Ik alle aan mij gestelde vragen in dit Medisch Portaal naar waarheid en volledigheid heb beantwoord.',
  [Labels.COMPLETE_DHMR_LI2]:
    'Mij bekend is dat ik De Hoop Maatwerkroute direct informeer als mijn gezondheid verandert nadat ik mijn medische dossier heb aangeleverd, maar voordat De Hoop Maatwerkroute mij definitief heeft geaccepteerd.',
  [Labels.COMPLETE_DHMR_LI3]:
    'Ik kennis genomen heb van het privacy Statement van {0}, te vinden op <a href="https://{1}">{2}</a>. Daarin staat onder andere dat {3} persoonsgegevens verwerkt en deelt met andere partijen voor zover dit nodig is voor het beoordelen, aangaan en uitvoeren van overeenkomsten.',
  [Labels.ERROR_HEADER]: 'Error',
  [Labels.ERROR_P1]:
    'An unknown (technical) error has occurred. We apologize for the inconvenience. Please try again or contact {0} for further instructions.',
  [Labels.ERROR_CONTACTS_HEADER]: 'Contact information:',
  [Labels.NON_AUTHORIZED_UNIQUE_URL]:
    'Please login using the unique URL in your email',
  [Labels.NON_AUTHORIZED_INVALID_QS1]:
    'The health declaration or invitation you are trying to reach does not exist, is archived or expired.',
  [Labels.NON_AUTHORIZED_INVALID_QS2]:
    'Please contact {0} for further instructions.',
  [Labels.NON_AUTHORIZED_LOGOUT_TITLE]: 'You have been logged out.',
  [Labels.NON_AUTHORIZED_LOGOUT_RETURN_LINK]:
    'If you’d like to continue, you can log in with the link that you’ve received in your email.',
  [Labels.NON_AUTHORIZED_KEYCLOAK_LOG_OUT]:
    'You are logged out from the health declaration because your session has ended. Everything you’ve entered in the declaration has been saved.',
  [Labels.PERSONAL_DETAILS_HEADER1]:
    'Your personal & General Practitioner data',
  [Labels.PERSONAL_DETAILS_HEADER2]: 'Your personal information',
  [Labels.PERSONAL_DETAILS_HEADER3]: 'Your general practitioner information',
  [Labels.PERSONAL_DETAILS_P1]:
    'We have already filled in your personal details for you. Please check your details and change them if they are incorrect. In addition, please fill in the details of your general practitioner.',
  [Labels.PERSONAL_DETAILS_P2]:
    'Please note: have you and any other insured person entered the same e-mail address in the health declaration? Our medical department Sends any additional medical information for both of you to the same e-mail address.',
  [Labels.PERSONAL_DETAILS_INITIALS]: 'initials',
  [Labels.PERSONAL_DETAILS_FIRST_NAME]: 'first name',
  [Labels.PERSONAL_DETAILS_MIDDLE_NAME]: 'middle name',
  [Labels.PERSONAL_DETAILS_LAST_NAME]: 'last name',
  [Labels.PERSONAL_DETAILS_GENDER]: 'gender',
  [Labels.PERSONAL_DETAILS_MALE]: 'male',
  [Labels.PERSONAL_DETAILS_FEMALE]: 'female',
  [Labels.PERSONAL_DETAILS_BIRTHDATE]: 'birthdate',
  [Labels.PERSONAL_DETAILS_NATIONALITY]: 'nationality',
  [Labels.PERSONAL_DETAILS_SSN]: 'SSN',
  [Labels.PERSONAL_DETAILS_PHONE]: 'phone',
  [Labels.PERSONAL_DETAILS_EMAIL]: 'email',
  [Labels.PERSONAL_DETAILS_STREET]: 'street',
  [Labels.PERSONAL_DETAILS_RESIDENCE]: 'residence',
  [Labels.PERSONAL_DETAILS_COUNTRY]: 'country',
  [Labels.PERSONAL_DETAILS_YOUR_DOCTOR]: 'your doctor',
  [Labels.PERSONAL_DETAILS_INTERNATIONAL_ADDRESS]:
    'this is an international address',
  [Labels.PERSONAL_DETAILS_ZIP_CODE_HOUSE_NUMBER]: 'zip code & house number',
  [Labels.PERSONAL_DETAILS_HOUSE_NUMBER]: 'house number',
  [Labels.PERSONAL_DETAILS_HOUSE_LETTER]: 'suffix',
  [Labels.PERSONAL_DETAILS_ZIP_CODE_NO_RESULT]:
    'No results could be found for the chosen zip code and house number combination. Please enter the street name and city manually.',
  [Labels.PERSONAL_DETAILS_ZIP_CODE]: 'zip code',
  [Labels.PROGRESS_BAR_STEP]: 'Step',
  [Labels.PROGRESS_BAR_STEP1]: 'Explanation',
  [Labels.PROGRESS_BAR_STEP2]: 'Your data',
  [Labels.PROGRESS_BAR_STEP3]: 'Questionnaire',
  [Labels.PROGRESS_BAR_STEP4]: 'Upload documents',
  [Labels.PROGRESS_BAR_STEP5]: 'Complete',
  [Labels.REJECTED_HEADER]: 'Health declaration rejected',
  [Labels.REJECTED_P]:
    'You have rejected your health declaration. You can edit the health declaration again by clicking the button below. You can sign your health declaration after you finished editing the answers.',
  [Labels.SIGNED_HEALTH_DEC_HEADER]:
    'Health declaration successfully completed',
  [Labels.SIGNED_HEALTH_DEC_WEFOX_HEADER]: 'Great, you made it!',
  [Labels.SIGNED_HEALTH_DEC_DHMR_HEADER]:
    'U heeft uw medische gegevens aangeleverd',
  [Labels.SIGNED_HEALTH_DEC_P1]:
    "Thank you for filling in and signing your health declaration. You can view your completed health declaration by clicking the button below. You don't have to send your health declaration to us by mail, this is automatically done by the {0} Online Health Declaration.",
  [Labels.SIGNED_HEALTH_DEC_DHMR_P1]:
    'Bedankt voor het aanleveren van uw medische gegevens. U kunt deze terugvinden door te klikken op de onderstaande knop. U hoeft de gegevens niet nog eens naar ons op te sturen. Dit gaat namelijk automatisch vanuit het Medisch Portaal van De Hoop Maatwerkroute.',
  [Labels.SIGNED_HEALTH_DEC_P2]:
    'How can I open my health declaration at a later time?',
  [Labels.SIGNED_HEALTH_DEC_DHMR_P2]:
    'Hoe kan ik mijn medische gegevens bekijken op een ander moment?',
  [Labels.SIGNED_HEALTH_DEC_P3]:
    "You can open your health declaration by clicking the link you received for filling in your health declaration. You can log in with your chosen password. You'll have 30 days to open your health declaration.",
  [Labels.SIGNED_HEALTH_DEC_DHMR_P3]:
    'U kunt uw medische gegevens bekijken door op de link te klikken die u eerder heeft gebruikt voor het aanleveren van de gegevens. U kunt dan weer inloggen met het door u gekozen wachtwoord. De gegevens blijven 30 dagen beschikbaar.',
  [Labels.SIGNED_HEALTH_DEC_P4]:
    'What happens after signing your health declaration?',
  [Labels.SIGNED_HEALTH_DEC_DHMR_P4]: 'Wat gaat er nu gebeuren?',
  [Labels.SIGNED_HEALTH_DEC_P5]:
    "The medical advisor looks at your answers and advises the insurer if he can accept the insurance. And if so, under which terms and conditions. It's possible that the medical advisor will need more information in order to give his advise. If so, he'll contact you in order to ask additional questions.",
  [Labels.SIGNED_HEALTH_DEC_DHMR_P5]:
    'De medisch adviseur kijkt naar uw gegevens en uw antwoorden en adviseert de verzekeraar of die de verzekering wel of niet kan accepteren. En zo ja, onder welke voorwaarden. Het kan zijn dat de medisch adviseur toch nog meer informatie nodig heeft om een goed advies te kunnen geven. Dan neemt hij contact met u op om aanvullende vragen te stellen.',
  [Labels.SIGNED_HEALTH_DEC_P6]:
    'What do you have to do if something changes in your health?',
  [Labels.SIGNED_HEALTH_DEC_P7]:
    'Has something changed in your health after you\'ve signed your health declaration, but before the insurance has been accepted? Then let us know as soon as possible in writing via <a href="mailto:{0}">{1}</a>. A change in your health can include complaints or ailments, but also a referral to a medical specialist or bloodwork.',
  [Labels.SIGNED_HEALTH_DEC_WEFOX_P7]:
    'Has anything changed in your health after you checked yours? You have signed a health declaration, but before the insurance application has been accepted, we ask you to let us know in writing as soon as possible <a href="mailto:{0}">{1}</a>',
  [Labels.SIGNED_HEALTH_DEC_DHMR_P7]:
    'Is er iets veranderd in uw gezondheid nadat u de verklaring heeft ondertekend, maar voordat de verzekering is geaccepteerd? Laat het ons dan zo snel mogelijk schriftelijk weten via <a href="mailto:{0}">{1}</a>. Een verandering in uw gezondheid kan bestaan uit nieuwe klachten of kwalen, maar ook uit een recente verwijzing naar een medisch specialist of een nieuw bloedonderzoek.',
  [Labels.WAITING_FOR_SIGNING_HEADER]:
    'Your health declaration is almost finished',
  [Labels.WAITING_FOR_SIGNING_WEFOX_HEADER]: 'Almost there!',
  [Labels.WAITING_FOR_SIGNING_P1]:
    'Your health declaration is ready to be signed. Click the button "Proceed to signing" below. You will be redirected to Signhost.  There you can sign the health declaration.',
  [Labels.WAITING_FOR_SIGNING_WEFOX_P1]:
    'Your health declaration is ready to be signed. Click the button below "Proceed to signature". You will be redirected to Signhost. You can get yours there Sign your health declaration quickly and easily digitally.',
  [Labels.WAITING_FOR_SIGNING_P2]:
    "We'll assume that your health declaration is filled in completely and truthfully. However, if you still want to change anything in your health declaration, please click the button “Edit health declaration”. You can then edit your details and sign the new version of your health declaration.",
  [Labels.WAITING_FOR_SIGNING_WEFOX_P2]:
    'We assume that you have completed your health declaration filled out truthfully. However, if you still have something on your If you would like to change your health declaration, please click on the button "Edit health declaration". You can then edit your details and the Sign a new version of your health declaration.',
  [Labels.ERROR_BLOCK_SINGLE_ERROR]: 'The following error has been found:',
  [Labels.ERROR_BLOCK_MULTIPLE_ERRORS]:
    'The following {0} errors have been found:',
  [Labels.ERROR_BLOCK_REQUIRED]: 'Some answers are required',
  [Labels.ERROR_BLOCK_INVALID_PHONE]:
    'Some questions have an invalid phone number',
  [Labels.ERROR_BLOCK_INVALID_EMAIL]:
    'Some questions have an invalid email address',
  [Labels.ERROR_BLOCK_INVALID_SSN]:
    'Some questions have an invalid social security number',
  [Labels.ERROR_BLOCK_INVALID_ZIP_CODE]:
    'Some questions have an invalid zip code',
  [Labels.ERROR_BLOCK_NO_DECIMALS_ALLOWED]:
    'Some questions are not whole numbers',
  [Labels.ERROR_BLOCK_WRONG_DATE]: 'Some questions have an invalid date',
  [Labels.ERROR_BLOCK_INTEGER_ABOVE_ZERO]:
    'Some answers have to be higher than 0',
  [Labels.ERROR_BLOCK_INTEGER_AT_LEAST_ZERO]:
    'Some answers have to be at least 0',
  [Labels.ERROR_BLOCK_AT_LEAST_ONE_SELECTED]:
    'Some answers have at least more than 1 option selected',
  [Labels.ERROR_BLOCK_AT_MOST_ONE_SELECTED]:
    'Some answers should not have more than 1 option selected',
  [Labels.ERROR_BLOCK_NOT_VALID_VALUE]: 'Some answers are not valid',
  [Labels.ERROR_BLOCK_VALUE_FROM_LIST]:
    'Some answers are not selected from the suggested list',
  [Labels.ERROR_BLOCK_WRONG_DATE_STOP_SMOKING_10_YEARS]:
    'Some questions have a date in wrong interval',
  [Labels.ERROR_REQUIRED]: 'This answer is mandatory',
  [Labels.ERROR_REQUIRED_OCCUPATION_HB]:
    'It is not possible to choose any other occupation than the one listed here. Please choose the one that most closely matches your occupation. If this is not possible, please contact your advisor.',
  [Labels.ERROR_INVALID_EMAIL]: "The email that's been entered is invalid",
  [Labels.ERROR_INVALID_PHONE]:
    "The phone number that's been entered is invalid",
  [Labels.ERROR_INVALID_SSN]:
    "The social security number that's been entered is invalid",
  [Labels.ERROR_INVALID_ZIP_CODE]:
    "The zip code that's been entered is invalid",
  [Labels.ERROR_HOUSE_NUMBER_IS_NOT_NUMERIC]: 'Only numbers are allowed',
  [Labels.ERROR_INTEGER_ABOVE_ZERO]:
    'The answer should be a number that is above zero',
  [Labels.ERROR_INTEGER_AT_LEAST_ZERO]:
    'The answer should be a number that is at least zero',
  [Labels.ERROR_FLOAT_ABOVE_ZERO]:
    'The answer should be a number that is above zero',
  [Labels.ERROR_FLOAT_AT_LEAST_ZERO]:
    'The answer should be a number that is at least zero',
  [Labels.ERROR_AT_LEAST_ONE_SELECTED]: 'Select at least one answer',
  [Labels.ERROR_AT_MOST_ONE_SELECTED]: 'Select no more than one answer',
  [Labels.ERROR_NO_DECIMALS_ALLOWED]: 'Please enter whole numbers',
  [Labels.ERROR_WRONG_DATE]: 'Wrong date',
  [Labels.ERROR_WRONG_DATE_STOP_SMOKING_10_YEARS]:
    'You indicated that you have not stopped smoking for 10 years or more. Enter a date less than 10 years ago or change the answer to the previous question.',
  [Labels.ERROR_VALUE_FROM_LIST]:
    'The value chosen is not valid. Please choose a value from the list',
  [Labels.DATE_PLACEHOLDER]: 'DD-MM-YYYY',
  [Labels.PRODUCT_TYPE_AP]: 'Alimony policy',
  [Labels.PRODUCT_TYPE_BG]: 'Basic Disability Self-employed insurance',
  [Labels.PRODUCT_TYPE_EOP]: 'Accident and Critical illness policy',
  [Labels.PRODUCT_TYPE_GG]: 'Disability Self-employed insurance',
  [Labels.PRODUCT_TYPE_MLB]: 'Monthly costs protector',
  [Labels.PRODUCT_TYPE_MLBZ]: 'Monthly costs protector Self-employed',
  [Labels.PRODUCT_TYPE_NB]: 'Inheritance insurance',
  [Labels.PRODUCT_TYPE_ORV]: 'Term life insurance',
  [Labels.PRODUCT_TYPE_TIB]: 'Income protector',
  [Labels.PRODUCT_TYPE_HB]: 'Mortgage Protector',
  [Labels.PRODUCT_TYPE_IZ]: 'InkomenZeker AOV',
  [Labels.PRODUCT_TYPE_UNKNOWN]: 'Unknown',
  [Labels.MAINTENANCE_HEADER]: 'The website is temporarily unavailable',
  [Labels.MAINTENANCE_P1]: 'Dear visitor,',
  [Labels.MAINTENANCE_P2]:
    'We are sorry that our website is temporarily unavailable. We do our utmost to get back to you as soon as possible. Apologies for the inconvenience.',
  [Labels.MAINTENANCE_P3]: 'Best regards,',
  [Labels.MAINTENANCE_P4]: '{0} team',
  [Labels.YES]: 'Yes',
  [Labels.NO]: 'No',
  [Labels.UNDERWRITER_TITLE]: 'Questionnaire',
  [Labels.UNDERWRITER_EXPLANATION]:
    'Please fill in the questionnaire below. It is divided into two categories: risk and health. Did the category turn green? Then you have answered all the questions in that category.',
  [Labels.DHMR_QUESTIONNAIRE_TITLE]: 'Health questions and medical records',
  [Labels.DHMR_QUESTIONNAIRE_EXPLANATION]:
    'Complete the questions below. You then add the medical file that you received from the insurer and your previous health declaration',
  [Labels.NEXT]: 'Next',
  [Labels.BACK]: 'Back',
  [Labels.ERROR_BLOCK_CATEGORY_LOADING_HEADER]: 'Something went wrong',
  [Labels.ERROR_BLOCK_CATEGORY_LOADING_P]:
    'We apologize. Please refresh the page and try again. Does the problem keep repeating itself? Please contact {0} via <a href="mailto:{1}">{2}</a> or via <a href="{3}">{4}</a> on working days between 09:00 and 17:00.',
  [Labels.ERROR_NOT_VALID_VALUE]: 'Please enter a valid number',
  [Labels.DOCUMENTS_UPLOAD_QUESTION_LABEL]:
    'Do you have any documents that support your health questions that you can upload? For example:',
  [Labels.DOCUMENTS_UPLOAD_LIST_ITEM_1]:
    'Most recent information from a GP or specialist',
  [Labels.DOCUMENTS_UPLOAD_LIST_ITEM_2]:
    'Most recent examination results, such as lab results or blood pressure readings',
  [Labels.DOCUMENTS_UPLOAD_AT_LEAST_ONE_ERROR_DHMR]:
    'To complete your application you have to upload your medical file',
  [Labels.DOCUMENTS_UPLOAD_FILES_TOTAL_SIZE]:
    'The maximum size of the files has been exceeded',
  [Labels.FILE_UPLOAD_LABEL1]: 'Drop file(s) here or',
  [Labels.FILE_UPLOAD_LABEL2]: 'choose',
  [Labels.FILE_UPLOAD_LABEL3]: 'some from your computer.',
  [Labels.FILE_UPLOAD_VALIDATION_LABEL1]:
    'Maximum size of files, no more than 2 Mb per file.',
  [Labels.FILE_UPLOAD_VALIDATION_LABEL2]:
    'Allowed file types: most common documents & images.',
  [Labels.FILE_UPLOAD_VALIDATION_LABEL3]: 'Zip files are not supported.',
  [Labels.HEALTH_DOC_SIZE_ERROR]:
    'This file exceeds the maximum filesize limit of {0} Mb.',
  [Labels.HEALTH_DOC_EXT_ERROR]: 'This filetype is not supported.',
  [Labels.HEALTH_DOC_DUPLICATION_ERROR]:
    'This document has already been uploaded.',
  [Labels.HEALTH_DOC_ERROR]: 'Error:',
  [Labels.HEALTH_DOC_REMOVE]: 'Remove',
  [Labels.HEALTH_DOC_DESCRIPTION_PLACEHOLDER]:
    'You can fill in a small description here',
  [Labels.HEALTH_DOC_TH1]: 'Uploaded files',
  [Labels.HEALTH_DOC_TH2]: 'Size',
  [Labels.HEALTH_DOC_TH3]: 'Status',
  [Labels.HEALTH_DOC_TH4]: 'Description',
  [Labels.HEALTH_DOC_TH5]: 'Actions',
  [Labels.HEALTH_DOC_CONFIRM_UPLOAD]: 'Confirm uploading',
  [Labels.HEALTH_DOC_UPLOADED]: 'Uploaded',
  [Labels.COOKIE_NOTIFICATION_MESSAGE]:
    'We use third-party cookies in order to provide the best user experience.',
  [Labels.COOKIE_NOTIFICATION_ALLOW]: 'Allow',
  [Labels.COOKIE_NOTIFICATION_DENY]: 'Deny',
  [Labels.DIGITAL_HEALTH_DECLARATION]: 'Digital Health Declaration',
  [Labels.HEALTH_DECLARATION_FILE_NAME]: 'health-declaration',
  [Labels.MEDICAL_REASON_FILE_NAME]: 'explanatory-advice',
  [Labels.VALIDATE_INSTRUCTION_ACCEPTED_CHECKBOX]:
    'You must agree to the terms and conditions to proceed. By checking the box, you declare your agreement.',
  [Labels.ERROR_INVALID_DATE]: 'This date is invalid',
  [Labels.COMPLETE_CHECKBOX_TITLE4]:
    'I agree that the outcome of the medical assessment (acceptance, premium surcharge, exclusions, rejection etc) will be communicated to the policyholder',
  [Labels.COMPLETE_CHECKBOX_LIST1]:
    'I have filled out this health declaration completely and truthfully;',
  [Labels.COMPLETE_CHECKBOX_LIST2]:
    'I will, until I have received notification that the insurer has accepted me, inform the insurer immediately if anything changes in my health situation;',
  [Labels.COMPLETE_CHECKBOX_LIST3]:
    'I agree that an automated decision can be made based on the information filled out;',
  [Labels.COMPLETE_CHECKBOX_LIST4]:
    'I agree that the outcome of the medical assessment (acceptance, premium surcharge, exclusions, rejection etc) will be communicated to the policyholder;',
  [Labels.COMPLETE_CHECKBOX_LIST5]:
    'I agree to TAF processing my personal data for the purpose of assessing the application and executing the insurance contract as stated in TAF\'s <a href="{0}" target="_blank" rel="noopener noreferrer">Privacy statement</a>;',
  [Labels.COMPLETE_CHECKBOX_LIST6]:
    'I agree that TAF may process my personal data for the purpose of entering into or administering another insurance policy of the same type with TAF.',
  [Labels.COMPLETE_CHECKBOX_LIST7]:
    'also explicitly consent to the insurer and its recipients and sub-recipients processing my health data as set out in the Policy Terms and Conditions <a href="{0}" target="_blank" rel="noopener noreferrer">Polisvoorwaarden | TAF Verzekeringen</a> and/or the insurer’s privacy notice <a href="{1}" target="_blank" rel="noopener noreferrer">Verzekeraars | TAF Verzekeringen</a> for the assessment, execution and performance of the insurance contract. This consent may be withdrawn at any time in the manner set out in the insurer’s privacy notice. Withdrawal of my consent will not affect any data processing carried out prior to such withdrawal. I am also informed that, where necessary for the establishment, exercise, or defence of a legal claim, my health data may be processed by the insurer and its recipients and sub-recipients without my consent.',
};

export default dictionary;
